import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FiGrid,
  FiPackage,
  FiShoppingCart,
  FiDollarSign,
  FiBarChart2,
  FiStar,
  FiHelpCircle,
  FiSettings,
  FiLogOut,
} from "react-icons/fi";
import Swal from "sweetalert2";
import "../../../assets/css/components/seller/sidebar/SellerSidebar.css";

const SellerSidebar = ({
  isCollapsed,
  setIsCollapsed,
  isMobileOpen,
  setIsMobileOpen,
  isMobile,
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#097d43",
      cancelButtonColor: "#dc3545",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("sellerEmail");
        localStorage.removeItem("sellerPassword");
        Swal.fire({
          title: "Logged Out!",
          text: "You have been logged out successfully.",
          icon: "success",
          confirmButtonColor: "#097d43",
          timer: 2000,
        }).then(() => navigate("/seller/login"));
      }
    });
  };

  const handleNavClick = () => {
    if (isMobile) setIsMobileOpen(false);
  };

  // ✅ Feather icons — bilkul admin jaisa
  const navItems = [
    { icon: FiGrid,        label: "Dashboard",   path: "/seller/dashboard" },
    { icon: FiPackage,     label: "My Products", path: "/seller/products"  },
    { icon: FiShoppingCart,label: "Orders",      path: "/seller/orders"    },
    { icon: FiDollarSign,  label: "Earnings",    path: "/seller/earnings"  },
    // { icon: FiBarChart2, label: "Analytics",  path: "/seller/analytics" },
    { icon: FiStar,        label: "Reviews",     path: "/seller/reviews"   },
    { icon: FiHelpCircle,  label: "Support",     path: "/seller/support"   },
    { icon: FiSettings,    label: "Settings",    path: "/seller/settings"  },
  ];

  const sidebarClass = [
    "sel-sidebar",
    isMobile ? "sel-sidebar--mobile" : "",
    isMobile && isMobileOpen ? "sel-sidebar--mobile-open" : "",
    !isMobile && isCollapsed ? "sel-sidebar--collapsed" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const showLabel = isMobile ? true : !isCollapsed;

  return (
    <>
      {isMobile && isMobileOpen && (
        <div
          className="sel-sidebar-overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <div className={sidebarClass}>
        {/* Logo */}
        <div
          className={`sel-sidebar__logo ${!showLabel ? "sel-sidebar__logo--centered" : ""}`}
        >
          <div className="sel-sidebar__logo-icon">K</div>
          {showLabel && (
            <div className="sel-sidebar__logo-text">
              <h4>Kisaan Mart</h4>
              <p>Seller Panel</p>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="sel-sidebar__nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.path} className="sel-sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className="sel-sidebar__nav-link"
                  onClick={handleNavClick}
                  title={!showLabel ? item.label : ""}
                >
                  <span className="sel-sidebar__nav-icon">
                    <Icon />
                  </span>
                  {showLabel && (
                    <span className="sel-sidebar__nav-label">{item.label}</span>
                  )}
                </NavLink>
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <button
          className={`sel-sidebar__logout ${!showLabel ? "sel-sidebar__logout--icon-only" : ""}`}
          onClick={handleLogout}
        >
          <span className="sel-sidebar__nav-icon">
            <FiLogOut />
          </span>
          {showLabel && <span>Logout</span>}
        </button>
      </div>
    </>
  );
};

export default SellerSidebar;
